import './index.scss'
function QuestionDiv(props) {
    return (
        <div className='question-div'>
            <div className='question-title heavy-title'>{props.title}</div>
            <div className='question-content' dangerouslySetInnerHTML={{__html:props.content}}></div>
        </div>
    )
}
export default QuestionDiv